<template>
    <div>
        <div>
            <database-filter :root="root" :database="database" :folder-select="false" :store="false" :codes="codes">
                <slot></slot>
            </database-filter>
        </div>

        <div v-if="isSelected">
            <span @click="codes.selected=[]">edit!</span>

            {{ codes.selected[0].text }}
        </div>
    </div>
</template>

<script>
    import DatabaseFilter from "./Filter";

    export default {
        name: "SingleSelectFilter",

        components: {
            DatabaseFilter,
        },

        props: {
            database: {
                type: String,
                required: true,
            },
            root: {
                type: String,
                default: '1',
            }
        },

        data() {
            return {
                codes: {
                    selected: [],
                },
            };
        },

        computed: {
            isSelected() {
                return this.codes.selected.length > 0;
            }
        },

        watch: {
            'codes.selected'() {
                if (this.isSelected) {
                    this.$emit('code', this.codes.selected[0]);
                }
            },
        },

        provide() {
            return {
                codes: this.codes,
            }
        },
    }
</script>